module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ppelv14-0318fa557219a8907afa8e351bc99461.jpg";